import axios from 'axios';
import toast from 'react-hot-toast';
import { ApiEndpoints } from '../../services/endpoints';
import { BASE_URL, apiService } from '../../services/service';
import {
    GET_LOCATION,
    UPDATE_PROFILE,
    UPDATE_PROFILE_FAIL,
    UPDATE_PROFILE_SUCCESS,
    CLEAR_FROM,
    GET_LOCATION_DETAILS,
} from '../actionTypes';

export const update_profile = (data, from) => async (dispatch) => {
    const body = data;
    try {
        dispatch({ type: UPDATE_PROFILE });
        const response = await apiService.post({
            url: `${BASE_URL}${ApiEndpoints.UPDATEPROFILE}`,
            payload: body,
        });
        dispatch({
            type: UPDATE_PROFILE_SUCCESS,
            payload: response,
            userData: data,
            from: from,
        });

        if (response.data.access_token) {
            localStorage.setItem('access_token', JSON.stringify(response.data.access_token));
            localStorage.setItem('token', JSON.stringify(response.data.access_token));
        }
        toast.success('Profile Updated!', { position: 'top-right' });
    } catch (error) {
        const message = error.response ? error.response.data.message : 'Network Error';
        dispatch({ type: UPDATE_PROFILE_FAIL, error: message });
        toast.error(message, {
            position: 'top-right',
        });
    }
};

export const getLocation = () => async (dispatch) => {
    axios
        .get('https://ipapi.co/json/')
        .then((response) => {
            let data = response.data;
            dispatch({ type: GET_LOCATION, payload: data.country_name });
            dispatch({ type: GET_LOCATION_DETAILS, payload: data });
        })
        .catch((error) => {
        });
};

export const clearFrom = () => (dispatch) => {
    dispatch({ type: CLEAR_FROM });
};
